var _rect, _path, _polyline, _line;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "rgba(0, 0, 0, 0.87)",
    viewBox: "0 0 256 256",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 256,
    height: 256,
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M224,177.3V78.7a8.1,8.1,0,0,0-4.1-7l-88-49.5a7.8,7.8,0,0,0-7.8,0l-88,49.5a8.1,8.1,0,0,0-4.1,7v98.6a8.1,8.1,0,0,0,4.1,7l88,49.5a7.8,7.8,0,0,0,7.8,0l88-49.5A8.1,8.1,0,0,0,224,177.3Z",
    fill: "none",
    stroke: "rgba(0, 0, 0, 0.87)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 12
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    points: "222.9 74.6 128.9 128 33.1 74.6",
    fill: "none",
    stroke: "rgba(0, 0, 0, 0.87)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 12
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 128.9,
    y1: 128,
    x2: 128,
    y2: 234.8,
    fill: "none",
    stroke: "rgba(0, 0, 0, 0.87)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 12
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBox);
export default __webpack_public_path__ + "static/media/box.1404f2049609027643b2962716c6cddd.svg";
export { ForwardRef as ReactComponent };